import {getSearchItemAttributes} from '../../../utils/search-analytics'
import React from 'react'
import {useShopperBasketsMutationHelper} from '@salesforce/commerce-sdk-react'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {useIntl} from 'react-intl'
import {useCustomToast} from '../../../contexts/custom-toast-context'
import {useAddToCartConfirmation} from '../../../contexts/add-to-cart-confirmation-context'
import {useAddToCartSource} from '../../../contexts/add-to-cart-source-context'
import {resolveAddToCartInteractionLocation, sendItemCartEvent} from '../../../utils/gtm-utils'
import {sendBrazeCartEvent} from '../../../utils/braze-utils'
import {trackAddToBagEvent} from '../../../utils/optimizely-exp-bag'

const useProductTileCart = ({
    product,
    variant,
    productId,
    id,
    isWishlistPage,
    removeItemFromWishlist,
    ref,
    setIsQuickViewOpen,
    isDesktop,
    onAddToCartModalOpen,
    onAddToCartModalClose,
    pathname
}) => {
    const {addItemToNewOrExistingBasket} = useShopperBasketsMutationHelper()
    const {showCustomToast} = useCustomToast()
    const navigate = useNavigation()
    const intl = useIntl()
    const {openConfirmation} = useAddToCartConfirmation()
    const {plpName, interactionLocation} = useAddToCartSource()

    const addProductToCart = async (productSelectionValues) => {
        try {
            const itemAddLocation = resolveAddToCartInteractionLocation(pathname, {
                isWishlistPage,
                plpName,
                interactionLocation
            })

            const productItems = productSelectionValues.map(({variant}) => ({
                productId: variant.productId,
                price: variant.price,
                quantity: 1,
                ...(itemAddLocation && {c_itemAddLocation: itemAddLocation}),
                ...getSearchItemAttributes(product, itemAddLocation)
            }))

            const basket = await addItemToNewOrExistingBasket(productItems)

            let productAdded = basket.productItems.find(item => item.productId === productItems[0].productId)

            // GTM Modification
            sendItemCartEvent(
                {
                    ...productAdded,
                    ...getSearchItemAttributes(product, itemAddLocation),
                    c_categories: productAdded?.c_categories || productItems[0]?.c_categories
                },
                false,
                null,
                itemAddLocation,
                basket.currency
            )

            // Braze Modification - Send Braze Cart Event
            sendBrazeCartEvent(basket, productSelectionValues[0]?.currentProduct, 'add')

            trackAddToBagEvent({
                product,
                sku: productItems[0].productId,
                value: productItems[0].price,
                quantity: productItems[0].quantity,
                source: 'product-tile'
            })

            return productSelectionValues
        } catch (error) {
            console.error('The error occured while adding a product to the basket: ', error)
        }
    }

    // Handle cart item addition with validation
    const handleCartItem = async () => {
        try {
            const itemsAdded = await addProductToCart([{product, variant}])

            if (itemsAdded) {
                // Remove from wishlist if on wishlist page
                if (isWishlistPage) {
                    const productObj = {productId: productId || id, ...product}
                    const context = /\/cart\/?$/.test(pathname ?? '')
                        ? 'wishlist-cart-carousel-context'
                        : 'add-to-cart-context'
                    await removeItemFromWishlist(productObj, ref?.current, context)
                }

                setIsQuickViewOpen(false)
                openConfirmation({product, variant, quantity: 1})
            }
        } catch (e) {
            console.log(e)
        }
    }

    return {handleCartItem}
}

export default useProductTileCart
